import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  const teamMembers = [
    {
      name: 'Mike Johnson',
      position: 'Master Technician',
      experience: '15+ Years Experience',
      image: 'https://public.readdy.ai/ai/img_res/62f3c9736c2cb348750da84b67ea2385.jpg'
    },
    {
      name: 'Sarah Davis',
      position: 'Service Manager',
      experience: '12+ Years Experience',
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20automotive%20service%20manager%20portrait%2C%20experienced%20automotive%20professional%20in%20clean%20uniform%2C%20confident%20and%20knowledgeable%20service%20manager%2C%20modern%20garage%20office%20background&width=300&height=300&seq=manager-sarah&orientation=squarish'
    },
    {
      name: 'Tom Wilson',
      position: 'Diagnostic Specialist',
      experience: '10+ Years Experience',
      image: 'https://readdy.ai/api/search-image?query=Professional%20automotive%20diagnostic%20specialist%20portrait%2C%20experienced%20technician%20with%20diagnostic%20equipment%2C%20skilled%20automotive%20professional%20in%20clean%20uniform%2C%20modern%20garage%20background&width=300&height=300&seq=tech-tom&orientation=squarish'
    }
  ];

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Service',
      description: 'We use only the highest quality parts and follow manufacturer specifications for all repairs and maintenance.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Customer First',
      description: 'Your satisfaction is our priority. We treat every customer with respect and provide transparent communication.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Expert Technicians',
      description: 'Our certified technicians have years of experience and stay current with the latest automotive technology.'
    },
    {
      icon: 'ri-time-line',
      title: 'Reliable Service',
      description: 'We respect your time and work efficiently to get you back on the road as quickly as possible.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative bg-cover bg-center bg-no-repeat h-96 flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Professional%20automotive%20repair%20shop%20exterior%20and%20interior%2C%20modern%20clean%20facility%2C%20welcoming%20atmosphere%2C%20professional%20automotive%20service%20center%2C%20quality%20repair%20facility%20with%20organized%20workspace&width=1920&height=400&seq=about-hero&orientation=landscape')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="text-white">
            <nav className="text-sm mb-4">
              <Link to="/" className="text-gray-300 hover:text-white cursor-pointer">Home</Link>
              <span className="mx-2 text-gray-400">/</span>
              <span className="text-white">About Us</span>
            </nav>
            <h1 className="text-5xl font-bold">About Sagil Service</h1>
            <p className="text-xl mt-4">Your trusted automotive service partner for over 37 years</p>
          </div>
        </div>
      </section>

      {/* Tony Ligas Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20experienced%20automotive%20mechanic%20portrait%2C%20master%20technician%20with%2037%20years%20experience%2C%20confident%20skilled%20automotive%20expert%20in%20clean%20uniform%2C%20trustworthy%20service%20provider%2C%20modern%20garage%20background&width=600&height=600&seq=tony-ligas&orientation=squarish"
                alt="Tony Ligas - Owner"
                className="rounded-lg shadow-xl object-cover w-full h-96"
              />
            </div>
            <div>
              <div className="inline-block bg-red-700 text-white px-4 py-2 rounded-full font-semibold mb-4">
                <i className="ri-award-line mr-2"></i>
                37 Years of Excellence
              </div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Meet Tony Ligas</h2>
              <p className="text-lg text-gray-700 mb-6">
                Tony Ligas, the owner and master technician at Sagil Service, has been serving the Passaic community and surrounding areas for over 37 years. His extensive experience and deep knowledge of automotive repair have made him a trusted name in the industry.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                With nearly four decades of hands-on experience, Tony has seen the automotive industry evolve from carburetors to computer-controlled systems. His commitment to continuous learning ensures that Sagil Service stays at the forefront of automotive technology while maintaining the traditional values of honest, quality service.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                Tony's passion goes beyond just fixing cars – he genuinely loves helping the community keep their vehicles safe and reliable. He believes that every customer deserves honest advice, transparent pricing, and repairs done right the first time. This philosophy has earned him the trust and loyalty of hundreds of families throughout Passaic and the surrounding areas.
              </p>
              <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-red-700">
                <p className="text-gray-800 italic text-lg">
                  "My goal has always been simple: treat every customer with respect and every vehicle with care. After 37 years, I still love what I do – helping people stay safe on the road and keeping our community's vehicles running strong."
                </p>
                <p className="text-gray-600 font-semibold mt-4">— Tony Ligas, Owner</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Content */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Story</h2>
              <p className="text-lg text-gray-700 mb-6">
                Sagil Service was founded with a simple mission: to provide honest, reliable, and professional automotive service to our community. From day one, we've been committed to treating every customer with respect and every vehicle with the care it deserves.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                Our team of experienced technicians brings decades of combined experience to every job. We stay current with the latest automotive technology and use state-of-the-art diagnostic equipment to ensure accurate repairs and maintenance.
              </p>
              <p className="text-lg text-gray-700">
                We believe in transparent communication, fair pricing, and quality workmanship. When you choose Sagil Service, you're choosing a partner who cares about your safety and satisfaction.
              </p>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20automotive%20repair%20shop%20interior%20with%20professional%20equipment%2C%20clean%20organized%20workspace%2C%20automotive%20lifts%20and%20diagnostic%20tools%2C%20professional%20service%20bay%20environment%2C%20quality%20automotive%20facility&width=600&height=400&seq=shop-interior&orientation=landscape"
                alt="Sagil Service shop interior"
                className="rounded-lg shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>

          {/* Values Section */}
          <div className="mb-16">
            <h2 className="text-4xl font-bold text-gray-900 text-center mb-12">Our Values</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {values.map((value, index) => (
                <div key={index} className="text-center p-6 bg-gray-50 rounded-lg">
                  <div className="w-16 h-16 mx-auto mb-4 bg-red-700 rounded-full flex items-center justify-center">
                    <i className={`${value.icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">{value.title}</h3>
                  <p className="text-gray-600">{value.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Community Commitment */}
          <div className="mb-16 bg-gradient-to-r from-red-700 to-red-600 text-white rounded-lg p-12">
            <div className="text-center max-w-3xl mx-auto">
              <i className="ri-community-line text-6xl mb-6"></i>
              <h2 className="text-4xl font-bold mb-6">Committed to Our Community</h2>
              <p className="text-xl mb-6">
                For over 37 years, Tony Ligas and the Sagil Service team have been dedicated to keeping Passaic and surrounding communities safe on the road. We're not just a repair shop – we're your neighbors, and we care about your family's safety.
              </p>
              <p className="text-lg">
                Every vehicle we service, every repair we make, and every customer we help is part of our commitment to building a safer, more reliable community. Your trust drives us to deliver excellence every single day.
              </p>
            </div>
          </div>

          {/* Warranty Section */}
          <div className="bg-red-700 text-white rounded-lg p-8 text-center">
            <i className="ri-shield-check-fill text-6xl text-yellow-400 mb-4"></i>
            <h3 className="text-3xl font-bold mb-4">Our Quality Guarantee</h3>
            <p className="text-xl mb-4">We stand behind our work with our quality promise</p>
            <div className="text-2xl font-semibold">
              Repairs Done Right The First Time
            </div>
            <p className="mt-4 text-lg">
              Quality workmanship you can trust
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Experience the Sagil Service Difference</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Ready to experience professional, honest automotive service? Contact us today to schedule your appointment.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/contact" 
              className="inline-flex items-center px-8 py-4 bg-red-700 hover:bg-red-600 text-white text-lg font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-line mr-2"></i>
              Schedule Service
            </Link>
            <div className="text-center">
              <a 
                href="tel:(973) 472-0890" 
                className="inline-flex items-center px-8 py-4 bg-red-700 hover:bg-red-600 text-white text-lg font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                Call (973) 472-0890
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
